const parseJson = (value, fallback, name) => {
  if (!value) return fallback;
  try {
    return JSON.parse(value);
  } catch {
    console.error(`${name} is not valid JSON; safe defaults are being used.`);
    return fallback;
  }
};

export const APP_CONFIG = Object.freeze({
  apiBaseUrl: (process.env.REACT_APP_BASE_API_URL || "").replace(/\/+$/, ""),
  roles: parseJson(
    process.env.REACT_APP_USER_ROLES_JSON,
    { ADMIN: "admin", CASHIER: "cashier" },
    "REACT_APP_USER_ROLES_JSON"
  ),
  orderTypes: parseJson(
    process.env.REACT_APP_ORDER_TYPES_JSON,
    { DINEIN: "dine-in", TAKEAWAY: "take-away" },
    "REACT_APP_ORDER_TYPES_JSON"
  ),
  paymentTypes: parseJson(
    process.env.REACT_APP_PAYMENT_TYPES_JSON,
    { CASH_PAYMENT: "Cash" },
    "REACT_APP_PAYMENT_TYPES_JSON"
  ),
  productCategories: parseJson(
    process.env.REACT_APP_PRODUCT_CATEGORIES_JSON,
    [],
    "REACT_APP_PRODUCT_CATEGORIES_JSON"
  ),
  defaultCustomerName: process.env.REACT_APP_DEFAULT_CUSTOMER_NAME || "Cash Customer",
  frontendUrl: process.env.REACT_APP_FRONTEND_URL || "",
  appName: process.env.REACT_APP_NAME || "Orderly",
  lowStockThreshold: Number(process.env.REACT_APP_LOW_STOCK_THRESHOLD || 5),
  addCustomer: process.env.REACT_APP_ADD_CUSTOMER === "true"
});
